@if (value) {
  <div class="notification-container" app-link-interceptor>
    <div class="notification" [ngClass]="getSeverityAsString(severity) | lowercase">
      <label [innerHTML]="value | iconReplace"></label>
    </div>
  </div>
}
@if (sslinks.length) {
  <div class="link-container buttons">
    @for (link of sslinks; track $index) {
      <button
        mat-stroked-button
        [class.icon]="link.icon"
        (click)="$event.stopImmediatePropagation(); onLinkClicked(link)"
        [innerHTML]="(link.icon ? createIconElement(link.icon) : link.value) | iconReplace"
      ></button>
    }
  </div>
}

@if (links.length) {
  <div class="link-container">
    @for (link of links; track $index) {
      <a [class.icon]="link.icon" [routerLink]="['/app/content', link.link]" [innerHTML]="(link.icon ? createIconElement(link.icon) : link.value) | iconReplace"></a>
    }
  </div>
}
